import { Button, Group, type MantineColor } from "@mantine/core";

interface BasicConfirmationFooterProps {
  confirmationButtonColor?: MantineColor;
  confirmationButtonText?: string;
  cancelButtonText?: string;
  error?: unknown;
  isConfirmationBtnDisabled?: boolean;
  isLoading?: boolean;
  toggleModal: () => void;
  onConfirm: () => void;
  onCancel?: () => void;
}

function BasicConfirmationFooter({
  confirmationButtonColor = "secondary",
  confirmationButtonText = "OK",
  cancelButtonText = "Abbrechen",
  error,
  isConfirmationBtnDisabled,
  isLoading = false,
  toggleModal,
  onConfirm,
  onCancel
}: BasicConfirmationFooterProps) {
  function handleClickCancel() {
    if (onCancel) {
      onCancel();
    }

    toggleModal();
  }

  const showCancelButton = !!onCancel && !error;
  const showCloseButton = !!error;
  const showConfirmButton = !error;

  return (
    <Group justify="space-between">
      <Group>
        {showCancelButton && (
          <Button
            disabled={isLoading}
            variant="default"
            onClick={handleClickCancel}
          >
            {cancelButtonText}
          </Button>
        )}
        {showCloseButton && (
          <Button variant="default" onClick={toggleModal}>
            Schließen
          </Button>
        )}
      </Group>
      {showConfirmButton && (
        <Button
          color={confirmationButtonColor}
          disabled={isConfirmationBtnDisabled}
          loading={isLoading}
          onClick={onConfirm}
        >
          {confirmationButtonText}
        </Button>
      )}
    </Group>
  );
}

export { BasicConfirmationFooter, BasicConfirmationFooterProps };
